module.exports = __webpack_public_path__ + "static/media/1-MCMChronologyVideo.da8a6a48.png";